import * as GC from "inputman.comment";
import { isEqual } from "../common/helper";
import React from "react";
var IMCtrl = "__gccomment";
export var GcComment = React.forwardRef(function (props, forwardRef) {
    var ref = React.useRef(null);
    var imCtrl = React.useRef(null);
    React.useEffect(function () {
        if (ref.current) {
            var container_1 = ref.current;
            var div = document.createElement("div");
            if (props.id) {
                div.id = props.id;
            }
            div.innerHTML = container_1.innerHTML;
            container_1.innerHTML = "";
            container_1.appendChild(div);
            var gcComment = new GC.InputMan.GcComment(div, props);
            imCtrl.current = gcComment;
            if (typeof forwardRef === 'function') {
                forwardRef({
                    getNestedIMControl: function () { return imCtrl.current; }
                });
            }
            else if (forwardRef) {
                forwardRef.current = {
                    getNestedIMControl: function () { return imCtrl.current; }
                };
            }
            if (ref.current) {
                ref.current[IMCtrl] = imCtrl.current;
            }
            if (props.onInitialized) {
                props.onInitialized(gcComment);
            }
            bindEvent(gcComment, props);
            return function () {
                var _a, _b;
                container_1.innerHTML = "";
                (_b = (_a = imCtrl.current) === null || _a === void 0 ? void 0 : _a.destroy) === null || _b === void 0 ? void 0 : _b.call(_a);
                imCtrl.current = null;
            };
        }
    }, []);
    // update props
    var hasMounted = React.useRef(false);
    React.useEffect(function () {
        var _a, _b;
        if (imCtrl.current) {
            if (!isEqual(props.userInfo, imCtrl.current.userInfo)) {
                if (!hasMounted.current && !props.userInfo) {
                    // not mounted and value is undefined, do nothing.
                }
                else {
                    imCtrl.current.userInfo = props.userInfo;
                }
            }
            if (!isEqual(props.comments, imCtrl.current.comments)) {
                if (!hasMounted.current && !props.comments) {
                    // not mounted and value is undefined, do nothing.
                }
                else {
                    if (props.comments instanceof Array) {
                        imCtrl.current.comments = (_a = props.comments) !== null && _a !== void 0 ? _a : [];
                    }
                }
            }
            if (!isEqual(props.stickedComment, imCtrl.current.stickedComment)) {
                if (!hasMounted.current && !props.stickedComment) {
                    // not mounted and value is undefined, do nothing.
                }
                else {
                    if (props.stickedComment) {
                        imCtrl.current.stickedComment = (_b = props.stickedComment) !== null && _b !== void 0 ? _b : null;
                    }
                }
            }
            if (!hasMounted.current) {
                hasMounted.current = true;
            }
        }
    }, [props.userInfo, props.comments, props.stickedComment]);
    var bindEvent = function (gcComment, props) {
        if (props.createEditor && typeof props.createEditor === "function") {
            gcComment.addEventListener(GC.InputMan.GcCommentEvent.CreateEditor, function (args) {
                return props.createEditor(args);
            });
        }
        gcComment.addEventListener(GC.InputMan.GcCommentEvent.EditorCreated, function (args) {
            if (typeof props.editorCreated === "function") {
                props.editorCreated(args);
            }
        });
        gcComment.addEventListener(GC.InputMan.GcCommentEvent.PreprocessError, function (args) {
            if (typeof props.preprocessError === "function") {
                props.preprocessError(args);
            }
        });
        gcComment.addEventListener(GC.InputMan.GcCommentEvent.BeforeExecuteCommand, function (args) {
            if (typeof props.beforeExecuteCommand === "function") {
                props.beforeExecuteCommand(args);
            }
        });
        gcComment.addEventListener(GC.InputMan.GcCommentEvent.AfterExecuteCommand, function (args) {
            if (typeof props.afterExecuteCommand === "function") {
                props.afterExecuteCommand(args);
            }
        });
        gcComment.addEventListener(GC.InputMan.GcCommentEvent.BeforeFirstLoad, function () {
            if (typeof props.beforeFirstLoad === "function") {
                props.beforeFirstLoad();
            }
        });
        gcComment.addEventListener(GC.InputMan.GcCommentEvent.AfterFirstLoad, function () {
            if (typeof props.afterFirstLoad === "function") {
                props.afterFirstLoad();
            }
        });
    };
    return (React.createElement("div", { id: props.id, className: props.className, ref: ref }));
});
